
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-fill",attrs:{"fill":"#D0EFEC","fill-rule":"evenodd","d":"M44 26c0 9.389-7.611 17-17 17s-17-7.611-17-17S17.611 9 27 9s17 7.611 17 17m-5 0c0 6.627-5.373 12-12 12-2.435 0-4.7-.725-6.593-1.972l16.621-16.62A11.94 11.94 0 0 1 39 26m-5.529-10.107A11.94 11.94 0 0 0 27 14c-6.627 0-12 5.373-12 12 0 2.383.695 4.604 1.893 6.471z","clip-rule":"evenodd"}}),_c('g',{staticClass:"i-free__stroke",attrs:{"stroke":"#234652"}},[_c('path',{staticClass:"i-Ellipse 563",attrs:{"d":"M16.162 30.74a14.5 14.5 0 0 1 23.091-16.993"}}),_c('path',{staticClass:"i-Ellipse 564",attrs:{"d":"M41.838 17.26a14.5 14.5 0 0 1-23.091 16.993"}}),_c('path',{staticClass:"i-Line 59",attrs:{"d":"m39.354 13.354-21 21"}})]),_c('g',{staticClass:"i-dollar-sign",attrs:{"stroke":"#234652"}},[_c('path',{staticClass:"i-Line 124",attrs:{"d":"M7.042 7.876v2.582"}}),_c('path',{staticClass:"i-Line 125",attrs:{"d":"M7.042 26.978v2.582"}}),_c('path',{staticClass:"i-Ellipse 603",attrs:{"d":"M2.888 22.843a4.095 4.095 0 1 0 7.353-2.788c-1.377-1.83-3.388-1.253-5.368-2.716-.51-.44-1.088-1.095-1.302-1.734a3.746 3.746 0 1 1 7.185-2.102"}})])])
          )
        }
      }
    